/**
 * 登录登出的服务端API调用方法
 * @author luwei
 */

import { post, postSafe } from '@/util/http'

/**
 * 用户登录
 * 路径修630改 xingnn 20200
 * @param {Object} params
 *            登录参数，例如username, password  之前路径为/security/login/login
 * @return Result 结果对象
 */
export const login = params => postSafe(`/femsLogin/user/login`, params, 3)

/**
 * 用户登出
 * @return Result 结果对象
 */
export const logout = () => post('/security/login/logout')

/**
 * 修改用户登录密码
 * @param {*} params password
 */
export const modifyPassword = params => postSafe(`/sum/user/modifyPassword`, params, 3)

/**
 * 修改用户名密码同步更新
 * @param {*} params password
 */
export const updateChangePasswordTime = params => postSafe(`/femsLogin/user/update/isPasswordInvalid`, params, 3)

/**
 * 获取用户头像图片
 * @return Result {username: "safer", portrait: "带固定前缀的base64编码的图片" }
 */
export const getPortrait = () => post('/sum/person/getPortrait')

export const userInfo = params => post(`/org/userManage/userInfo`, params)
